jQuery(document).ready(function($) {
    const base = "gc-navbar";
    $(`.${base}__toggle`).click(function(e) {
        e.preventDefault();
        
        $(`.${base}__right`).toggleClass(`${base}__right--opened`);
    });
});